module.exports = __webpack_public_path__ + "img/073.846775a9.png";